export default "__VITE_ASSET__a5298f44__"